import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomer } from "../../models/Customer/Customer";

export default function useCustomers() {
  const { get } = useApiHelper();

  const customers = useQuery({
    queryKey: CustomerQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<ICustomer[]>>("/customer").then((res) => res.data),
  });

  return {
    customers,
  };
}
